import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import $image_url from 'js/utils/image_url';

export class PremiumIcon extends React.Component {
  static propTypes = {
    popoverBodyText: PropTypes.string,
    popoverLinkUrl: PropTypes.string,
    popoverContainer: PropTypes.string,
    disableHoverBehavior: PropTypes.bool,
    popoverButtonText: PropTypes.string,
  };

  initHoverPopover = (el) => {
    if (this.props.disableHoverBehavior) return null;
    if (!el) {
      if (this.popover) this.popover.remove();
      return;
    }

    this.popover = new HoverPopover({
      el: $(el).closest('.js-PremiumIconContainerHoverWrapper'),
      content: JST['premium/templates/premium_icon']({
        bodyText: this.props.popoverBodyText,
        learnMoreLinkUrl: this.props.popoverLinkUrl,
        buttonText: this.props.popoverButtonText,
      }),
      before_show: function (show) {
        $(this.popover.$el.data('bs.popover').tip()).css('max-width', 'none');
        show();
      }.bind(this),
      placement: 'bottom',
      html: true,
      container: this.props.popoverContainer,
      hide_delay: 300,
    });
  };

  render() {
    const containerClasses = classNames(
      'PremiumIconContainer',
      this.props.className,
      {
        'PremiumIconContainer--enableHoverBehavior':
          !this.props.disableHoverBehavior,
      },
    );
    return (
      <div
        className={containerClasses}
        style={this.props.style || {}}
        ref={this.initHoverPopover}
      >
        <img
          className="PremiumIconContainer-gold"
          src={$image_url('flexible_premium_upgrade/premium_icon_gold.svg')}
          style={{ width: '12px' }}
        />
        <img
          className="PremiumIconContainer-gray"
          src={$image_url('flexible_premium_upgrade/premium_icon_gray.svg')}
          style={{ width: '12px' }}
        />
      </div>
    );
  }
}
